import { render, staticRenderFns } from "./LockedRecord.vue?vue&type=template&id=102f6b2a&"
import script from "./LockedRecord.vue?vue&type=script&lang=js&"
export * from "./LockedRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports